import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {
    factor: number;
}

export const ResultPercentage: FunctionComponent<OwnProps> = ({factor}) => {
    const percentage = factor * 100;
    const formattedPercentage = `${percentage.toFixed(2)}%`;

    if (percentage < 0) {
        return <span style={{color: 'red'}}>{formattedPercentage}</span>;
    }
    if (percentage > 0) {
        return <span style={{color: 'green'}}>{formattedPercentage}</span>;
    }

    return <span>{formattedPercentage}</span>;
};
